import { ReportPreset } from '@intelligent-play-v2/domain';
import { queryBuilder } from '~/api';

export const deletePreset = async (presetId: number): Promise<ReportPreset> => {
  const { data } = await queryBuilder('DELETE', `reports/presets/${presetId}`);
  return data;
};
